/**
 * We store requireKAALCookie here to break the circular dependency of
 * khan-fetch.js -> cookie-refresh.js -> apollo-fetch.js ->
 *     create-client.js -> khan-fetch.js
 * This is set by CookieRefresh.init() inside @khan/app-shell.
 */
let requireKAALCookie = (request: Request): Promise<Request> =>
    Promise.resolve(request);

export const getRequireKAALCookie = () => requireKAALCookie;

export const setRequireKAALCookie = (
    incomingRequireKAALCookie: (request: Request) => Promise<Request>,
) => {
    requireKAALCookie = incomingRequireKAALCookie;
};

export const resetRequireKAALCookie = () => {
    requireKAALCookie = (request: Request) => Promise.resolve(request);
};
